import { BrandingIconSet } from '@/configs/domain-branding.config'

/**
 * Applies tenant `defaultFaviconUrl` over domain branding icons when set.
 */
export function resolveBrandingIconSet(
  domainIcons: BrandingIconSet,
  tenantFaviconUrl?: string | null
): BrandingIconSet {
  const faviconUrl = tenantFaviconUrl?.trim()
  if (!faviconUrl) {
    return domainIcons
  }

  return {
    ico: faviconUrl,
    png16: faviconUrl,
    png32: faviconUrl,
    appleTouchIcon: faviconUrl,
    manifest: domainIcons.manifest,
  }
}

export function getFaviconMimeType(url: string): string {
  const lowered = url.toLowerCase()
  if (lowered.endsWith('.svg')) return 'image/svg+xml'
  if (lowered.endsWith('.png')) return 'image/png'
  if (lowered.endsWith('.jpg') || lowered.endsWith('.jpeg')) return 'image/jpeg'
  if (lowered.endsWith('.webp')) return 'image/webp'
  return 'image/x-icon'
}
